module.exports = __webpack_public_path__ + "static/media/instaCloneImg.55b0f437.png";